import { Component, OnInit } from '@angular/core';
import { ApiService } from './services/api.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'app';
  contentIsLoaded: boolean = false;
  communitiesIsLoaded: boolean = false;
  constructor(
    private _api: ApiService
    
  ) { }
  ngOnInit() {
    
  }
}



// WEBPACK FOOTER //
// /mnt/disk/stratbox.dev/src/app/app.component.ts